"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useFirstMountState } from "./use-first-mount-state";

// This hook is meant to help with cases where we are layering react state on top of gql store
// In those cases, there is a possibility that we refetch the query in background, and would have
// to update the react state to reflect that. Once we will fully utilise gql store (e.g graphcache)
// we can get rid of this
export function useSyncState(initialItem) {
  const $ = _c(7);
  const [item, setItem] = useState(initialItem);
  const isFirstMount = useFirstMountState();
  let t0;
  if ($[0] !== initialItem || $[1] !== isFirstMount) {
    t0 = () => {
      if (!isFirstMount) {
        setItem(initialItem);
      }
    };
    $[0] = initialItem;
    $[1] = isFirstMount;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== initialItem) {
    t1 = [initialItem];
    $[3] = initialItem;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== item) {
    t2 = [item, setItem];
    $[5] = item;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}